module.exports = __webpack_public_path__ + "static/img/man.c968938a.png";